export default __webpack_public_path__ + "static/media/disable_srch.409c90fb.svg";